import { onAddDelay } from "../../utils/DelayNode";

export const createDelayNode = ({ dispatch, nodes, nodeId }) => {
  const currNode = nodes.find((node) => node.id === nodeId);

  const axis = {
    x: currNode.position.x + 180,
    y: currNode.position.y - 1,
  };

  onAddDelay(dispatch, axis, nodeId);
};
